import { jsPDF } from "jspdf";

const GOLD = [255, 211, 0];
const INK = [20, 20, 20];
const GREY = [110, 110, 110];
const M = 44;

export function downloadChecklist(p) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  let y = 0;

  doc.setFillColor(...INK); doc.rect(0, 0, W, 70, "F");
  doc.setFillColor(...GOLD); doc.rect(0, 70, W, 4, "F");
  doc.setTextColor(255, 255, 255); doc.setFont("helvetica", "bold"); doc.setFontSize(9);
  doc.text("SECRECY EXECUTIVE TRAINING ACADEMY  ·  AFTER-CLASS CHECKLIST", M, 26);
  doc.setFontSize(16); doc.text(doc.splitTextToSize(p.title, W - 2 * M - 90), M, 50);
  doc.setFillColor(...GOLD); doc.roundedRect(W - M - 80, 32, 80, 24, 3, 3, "F");
  doc.setTextColor(...INK); doc.setFontSize(11); doc.text(`${p.state} · ${p.code}`, W - M - 40, 48, { align: "center" });

  y = 94;
  doc.setTextColor(...GREY); doc.setFont("helvetica", "normal"); doc.setFontSize(8);
  doc.text(`Agency: ${p.agency.name}`, M, y); y += 11;
  doc.text(`Portal: ${p.portal.url}`, M, y); y += 11;
  doc.text(`Fee ${p.summary.fee}   ·   Processing ${p.summary.processing}   ·   Valid ${p.summary.validity}   ·   Prints: ${p.summary.prints}`, M, y);
  y += 20;

  const colW = (W - 2 * M - 16) / 2;
  const leftX = M, rightX = M + colW + 16;

  const heading = (x, yy, t) => {
    doc.setTextColor(...INK); doc.setFont("helvetica", "bold"); doc.setFontSize(9.5);
    doc.text(t.toUpperCase(), x, yy);
    doc.setDrawColor(...GOLD); doc.setLineWidth(1.2); doc.line(x, yy + 3, x + 60, yy + 3);
    return yy + 14;
  };

  let ly = heading(leftX, y, "Steps — check off as you go");
  doc.setFont("helvetica", "normal"); doc.setFontSize(8.2); doc.setTextColor(...INK);
  p.steps.forEach((s) => {
    doc.setDrawColor(...INK); doc.setLineWidth(0.8); doc.rect(leftX, ly - 7, 8, 8);
    doc.setFont("helvetica", "bold");
    const t = doc.splitTextToSize(s.t, colW - 14);
    doc.text(t, leftX + 13, ly); ly += t.length * 9.5;
    doc.setFont("helvetica", "normal"); doc.setTextColor(...GREY);
    const d = doc.splitTextToSize(s.d, colW - 14);
    doc.text(d, leftX + 13, ly); ly += d.length * 9 + 5;
    doc.setTextColor(...INK);
  });

  ly += 6;
  ly = heading(leftX, ly, "Bring / upload");
  doc.setFont("helvetica", "normal"); doc.setFontSize(8.2); doc.setDrawColor(...INK); doc.setLineWidth(0.8);
  p.documents.forEach((d) => {
    doc.rect(leftX, ly - 7, 8, 8);
    const t = doc.splitTextToSize(d, colW - 14);
    doc.text(t, leftX + 13, ly); ly += t.length * 9.5 + 2;
  });

  let ry = heading(rightX, y, "Fingerprinting");
  doc.setFont("helvetica", "normal"); doc.setFontSize(8.2); doc.setTextColor(...INK);
  const how = doc.splitTextToSize(p.fingerprints.how, colW);
  doc.text(how, rightX, ry); ry += how.length * 9.5 + 2;
  doc.setFont("courier", "bold"); doc.setFontSize(8);
  p.fingerprints.details.forEach((d) => {
    const t = doc.splitTextToSize(d, colW);
    doc.text(t, rightX, ry); ry += t.length * 9.5;
  });
  ry += 10;

  ry = heading(rightX, ry, "Fees");
  doc.setFont("helvetica", "normal"); doc.setFontSize(8.2);
  p.fees.forEach(([label, amt]) => {
    doc.setTextColor(...GREY); doc.text(label, rightX, ry);
    doc.setTextColor(...INK); doc.setFont("courier", "bold");
    const a = doc.splitTextToSize(amt, colW * 0.5);
    doc.text(a, rightX + colW, ry, { align: "right" });
    doc.setFont("helvetica", "normal"); ry += Math.max(1, a.length) * 9.5 + 1;
  });
  ry += 10;

  ry = heading(rightX, ry, "Appointment record");
  doc.setFont("helvetica", "normal"); doc.setFontSize(8.2); doc.setTextColor(...GREY);
  ["Fingerprint appointment date / time", "Location / vendor", "LiveScan or receipt / confirmation #", "Application / tracking #", "Date submitted", "Decision date"].forEach((lab) => {
    doc.text(lab, rightX, ry); doc.setDrawColor(150, 150, 150); doc.setLineWidth(0.5);
    doc.line(rightX, ry + 11, rightX + colW, ry + 11); ry += 24;
  });

  const footY = H - 30;
  doc.setDrawColor(...GOLD); doc.setLineWidth(1); doc.line(M, footY - 12, W - M, footY - 12);
  doc.setFontSize(7); doc.setTextColor(...GREY); doc.setFont("helvetica", "normal");
  doc.text("Fees, forms and processing times are set by each agency and change without notice — confirm on the official site before paying.", M, footY);
  doc.text("Secrecy Executive Protection LLC · 410-645-0722 · info@seprotection.com · seprotection.com/resources", M, footY + 10);

  doc.save(`SEP-Checklist-${p.state}-${p.code}.pdf`);
}
